// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `       /*** ESSENTIAL STYLES ***/
            .sf-menu, .sf-menu * {
                margin: 0;
                padding: 0;
                list-style: none;
            }

            .sf-menu li {
                position: relative;
            }

            .sf-menu ul {
                position: absolute;
                display: none;
                top: 100%;
                left: 0;
                z-index: 99;
            }

            .sf-menu > li {
                float: left;
            }

            .sf-menu li:hover > ul,
            .sf-menu li.sfHover > ul {
                display: block;
            }

            .sf-menu a {
                display: block;
                position: relative;
            }

            .sf-menu ul ul {
                top: 0;
                left: 100%;
            }


            /*** SKIN ***/
            .sf-menu {
                float: left;
                margin-bottom: 1em;
            }

            .sf-menu ul {
                box-shadow: 2px 2px 6px rgba(0, 0, 0, .2);
                min-width: 12em; /* allow long menu items to determine submenu width */
                *width: 12em; /* no auto sub width for IE7, see white-space comment below */
            }

            .sf-menu a {
                /* border-left: 1px solid #fff; */
                /* border-top: 1px solid #dFeEFF; */ /* fallback colour must use full shorthand */
                /* border-top: 1px solid rgba(255,255,255,.5); */
                padding: .75em 1em;
                text-decoration: none;
                zoom: 1; /* IE7 */
            }

            .sf-menu a {
                color: black;
                font-weight: bold;
            }

            /* menu items */
            .sf-menu li {
                background: white;
                white-space: nowrap; /* no need for Supersubs plugin */
                *white-space: normal; /* ...unless you support IE7 (let it wrap) */
                -webkit-transition: background .2s;
                transition: background .2s;
            }

            /* second level dropdown menu items */
            .sf-menu ul li {
                background: white;
            }

            /* third level dropdown menu items */
            .sf-menu ul ul li {
                background: white;
            }

            /* first level menu items hover */
            .sf-menu li:hover,
            .sf-menu li.sfHover {
                background: white;
                /* only transition out, not in */
                -webkit-transition: none;
                transition: none;
            }

            /*** arrows (for all except IE7) **/
            /*.sf-arrows .sf-with-ul {*/
            /*	padding-right: 2.5em;*/
            /*	*padding-right: 1em; !* no CSS arrows for IE7 (lack pseudo-elements) *!*/
            /*}*/
            /*!* styling for both css and generated arrows *!*/
            /*.sf-arrows .sf-with-ul:after {*/
            /*	content: '';*/
            /*	position: absolute;*/
            /*	top: 50%;*/
            /*	right: 1em;*/
            /*	margin-top: -3px;*/
            /*	height: 0;*/
            /*	width: 0;*/
            /*	!* order of following 3 rules important for fallbacks to work *!*/
            /*	border: 5px solid transparent;*/
            /*	border-top-color: #dFeEFF; !* edit this to suit design (no rgba in IE8) *!*/
            /*	border-top-color: rgba(255,255,255,.5);*/
            /*}*/
            /*.sf-arrows > li > .sf-with-ul:focus:after,*/
            /*.sf-arrows > li:hover > .sf-with-ul:after,*/
            /*.sf-arrows > .sfHover > .sf-with-ul:after {*/
            /*	border-top-color: white; !* IE8 fallback colour *!*/
            /*}*/
            /*!* styling for right-facing arrows *!*/
            /*.sf-arrows ul .sf-with-ul:after {*/
            /*	margin-top: -5px;*/
            /*	margin-right: -3px;*/
            /*	border-color: black;*/
            /*	border-left-color: #dFeEFF; !* edit this to suit design (no rgba in IE8) *!*/
            /*	border-left-color: rgba(255,255,255,.5);*/
            /*}*/
            /*.sf-arrows ul li > .sf-with-ul:focus:after,*/
            /*.sf-arrows ul li:hover > .sf-with-ul:after,*/
            /*.sf-arrows ul .sfHover > .sf-with-ul:after {*/
            /*	border-left-color: greenyellow;*/
            /*}*/`, "",{"version":3,"sources":["webpack://./assets/src/phi/superfish.css"],"names":[],"mappings":"OAAO,yBAAyB;YACpB;gBACI,SAAS;gBACT,UAAU;gBACV,gBAAgB;YACpB;;YAEA;gBACI,kBAAkB;YACtB;;YAEA;gBACI,kBAAkB;gBAClB,aAAa;gBACb,SAAS;gBACT,OAAO;gBACP,WAAW;YACf;;YAEA;gBACI,WAAW;YACf;;YAEA;;gBAEI,cAAc;YAClB;;YAEA;gBACI,cAAc;gBACd,kBAAkB;YACtB;;YAEA;gBACI,MAAM;gBACN,UAAU;YACd;;;YAGA,aAAa;YACb;gBACI,WAAW;gBACX,kBAAkB;YACtB;;YAEA;gBACI,yCAAyC;gBACzC,eAAe,EAAE,qDAAqD;iBACtE,WAAY,EAAE,6DAA6D;YAC/E;;YAEA;gBACI,iCAAiC;gBACjC,mCAAmC,EAAE,4CAA4C;gBACjF,gDAAgD;gBAChD,kBAAkB;gBAClB,qBAAqB;gBACrB,OAAO,EAAE,QAAQ;YACrB;;YAEA;gBACI,YAAY;gBACZ,iBAAiB;YACrB;;YAEA,eAAe;YACf;gBACI,iBAAiB;gBACjB,mBAAmB,EAAE,iCAAiC;iBACtD,mBAAoB,EAAE,4CAA4C;gBAClE,kCAAkC;gBAClC,0BAA0B;YAC9B;;YAEA,qCAAqC;YACrC;gBACI,iBAAiB;YACrB;;YAEA,oCAAoC;YACpC;gBACI,iBAAiB;YACrB;;YAEA,iCAAiC;YACjC;;gBAEI,iBAAiB;gBACjB,gCAAgC;gBAChC,wBAAwB;gBACxB,gBAAgB;YACpB;;YAEA,mCAAmC;YACnC,2BAA2B;YAC3B,yBAAyB;YACzB,2EAA2E;YAC3E,IAAI;YACJ,kDAAkD;YAClD,iCAAiC;YACjC,gBAAgB;YAChB,uBAAuB;YACvB,aAAa;YACb,eAAe;YACf,qBAAqB;YACrB,cAAc;YACd,aAAa;YACb,oEAAoE;YACpE,kCAAkC;YAClC,8EAA8E;YAC9E,2CAA2C;YAC3C,IAAI;YACJ,6CAA6C;YAC7C,6CAA6C;YAC7C,8CAA8C;YAC9C,sDAAsD;YACtD,IAAI;YACJ,wCAAwC;YACxC,oCAAoC;YACpC,qBAAqB;YACrB,uBAAuB;YACvB,wBAAwB;YACxB,+EAA+E;YAC/E,4CAA4C;YAC5C,IAAI;YACJ,8CAA8C;YAC9C,8CAA8C;YAC9C,+CAA+C;YAC/C,mCAAmC;YACnC,IAAI","sourcesContent":["       /*** ESSENTIAL STYLES ***/\n            .sf-menu, .sf-menu * {\n                margin: 0;\n                padding: 0;\n                list-style: none;\n            }\n\n            .sf-menu li {\n                position: relative;\n            }\n\n            .sf-menu ul {\n                position: absolute;\n                display: none;\n                top: 100%;\n                left: 0;\n                z-index: 99;\n            }\n\n            .sf-menu > li {\n                float: left;\n            }\n\n            .sf-menu li:hover > ul,\n            .sf-menu li.sfHover > ul {\n                display: block;\n            }\n\n            .sf-menu a {\n                display: block;\n                position: relative;\n            }\n\n            .sf-menu ul ul {\n                top: 0;\n                left: 100%;\n            }\n\n\n            /*** SKIN ***/\n            .sf-menu {\n                float: left;\n                margin-bottom: 1em;\n            }\n\n            .sf-menu ul {\n                box-shadow: 2px 2px 6px rgba(0, 0, 0, .2);\n                min-width: 12em; /* allow long menu items to determine submenu width */\n                *width: 12em; /* no auto sub width for IE7, see white-space comment below */\n            }\n\n            .sf-menu a {\n                /* border-left: 1px solid #fff; */\n                /* border-top: 1px solid #dFeEFF; */ /* fallback colour must use full shorthand */\n                /* border-top: 1px solid rgba(255,255,255,.5); */\n                padding: .75em 1em;\n                text-decoration: none;\n                zoom: 1; /* IE7 */\n            }\n\n            .sf-menu a {\n                color: black;\n                font-weight: bold;\n            }\n\n            /* menu items */\n            .sf-menu li {\n                background: white;\n                white-space: nowrap; /* no need for Supersubs plugin */\n                *white-space: normal; /* ...unless you support IE7 (let it wrap) */\n                -webkit-transition: background .2s;\n                transition: background .2s;\n            }\n\n            /* second level dropdown menu items */\n            .sf-menu ul li {\n                background: white;\n            }\n\n            /* third level dropdown menu items */\n            .sf-menu ul ul li {\n                background: white;\n            }\n\n            /* first level menu items hover */\n            .sf-menu li:hover,\n            .sf-menu li.sfHover {\n                background: white;\n                /* only transition out, not in */\n                -webkit-transition: none;\n                transition: none;\n            }\n\n            /*** arrows (for all except IE7) **/\n            /*.sf-arrows .sf-with-ul {*/\n            /*\tpadding-right: 2.5em;*/\n            /*\t*padding-right: 1em; !* no CSS arrows for IE7 (lack pseudo-elements) *!*/\n            /*}*/\n            /*!* styling for both css and generated arrows *!*/\n            /*.sf-arrows .sf-with-ul:after {*/\n            /*\tcontent: '';*/\n            /*\tposition: absolute;*/\n            /*\ttop: 50%;*/\n            /*\tright: 1em;*/\n            /*\tmargin-top: -3px;*/\n            /*\theight: 0;*/\n            /*\twidth: 0;*/\n            /*\t!* order of following 3 rules important for fallbacks to work *!*/\n            /*\tborder: 5px solid transparent;*/\n            /*\tborder-top-color: #dFeEFF; !* edit this to suit design (no rgba in IE8) *!*/\n            /*\tborder-top-color: rgba(255,255,255,.5);*/\n            /*}*/\n            /*.sf-arrows > li > .sf-with-ul:focus:after,*/\n            /*.sf-arrows > li:hover > .sf-with-ul:after,*/\n            /*.sf-arrows > .sfHover > .sf-with-ul:after {*/\n            /*\tborder-top-color: white; !* IE8 fallback colour *!*/\n            /*}*/\n            /*!* styling for right-facing arrows *!*/\n            /*.sf-arrows ul .sf-with-ul:after {*/\n            /*\tmargin-top: -5px;*/\n            /*\tmargin-right: -3px;*/\n            /*\tborder-color: black;*/\n            /*\tborder-left-color: #dFeEFF; !* edit this to suit design (no rgba in IE8) *!*/\n            /*\tborder-left-color: rgba(255,255,255,.5);*/\n            /*}*/\n            /*.sf-arrows ul li > .sf-with-ul:focus:after,*/\n            /*.sf-arrows ul li:hover > .sf-with-ul:after,*/\n            /*.sf-arrows ul .sfHover > .sf-with-ul:after {*/\n            /*\tborder-left-color: greenyellow;*/\n            /*}*/"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
